import { useMutation, gql } from "@apollo/client"
import serializationKeys from "../serializationKeys"
import { JOB_FIELDS } from "./useQueryJobs"

const COMPLETE_JOB_TASK_MUTATION = gql`
  ${JOB_FIELDS}
  mutation CompleteJobTask($id: ID!, $complete: Boolean!) {
    completeJobTask(id: $id, complete: $complete) {
      ...JobFields
    }
  }
`

const useMutationCompleteJobTask = (job) =>
  useMutation(COMPLETE_JOB_TASK_MUTATION, {
    context: {
      serializationKey: serializationKeys.job(job),
    },
  })

export { useMutationCompleteJobTask }
